export default "__VITE_ASSET__BFWEz0Nq__"